{
  "close": "Затвори"
}
